<script>
export default {
    name: "VoucherDetailsPrint",

    data() {

        return {
            voucherItems: {
                voucherDetails: [],
                dedcutions: [],
            },
            consultant: {},
        };
    },

    computed: {

        total() {
            if(!this.voucherItems.voucherDetails.length) return 0;

            return this.voucherItems.voucherDetails
                .map(voucherItem => parseFloat(voucherItem.voucherAmount))
                .reduce((sum,amt) => sum+amt);
        },

        customDeductions() {
            if(!this.voucherItems.dedcutions.length) return 0;

            const customDeductions = this.voucherItems.dedcutions.filter(ded => !ded.isKra);

            return customDeductions.length ? customDeductions
                .map(deduction => parseFloat(deduction.deductionAmount))
                .reduce((sum,amt) => sum+amt) : 0;
        },

        kraDeductions() {
            if(!this.voucherItems.dedcutions.length) return 0;

            const deductions = this.voucherItems.dedcutions.filter(ded => ded.isKra);

            return deductions.length ? deductions
                .map(deduction => parseFloat(deduction.deductionAmount))
                .reduce((sum,amt) => sum+amt) : 0;
        },
    },

    mounted() {

        this.$root.loading=true;
        Promise.all([this.fetchVoucherDetails(), this.fetchConsultant(), ]).then(() => {
            this.$root.loading=false;
            setTimeout(() => {
                window.print();
            }, 200);
        }).catch(() => {this.$root.loading=false;});
    },

    methods: {

        fetchVoucherDetails() {

            return this.$http.get(`Finance/GetPaymentVoucherDetails?VoucherNo=${this.$route.params.voucherNo}&VoucherType=1`).then(response => {
                this.voucherItems=response.data;
            }).catch(() => {});
        },

        fetchConsultant() {
            let url = `MasterData/GetSpecificConsultant`;
                url += `?ConsultantID=${this.$route.query.consultant}`;
    
            return this.$http.get(url).then(response => {
                    this.consultant=response.data.length ? response.data[0] : {};
                }).catch(() => {});
        },
    },
}
</script>
<template>
    <div class="w-full flex flex-wrap items-center">
        <div class="w-full flex justify-center my-3">
            <tail-address-header></tail-address-header>
        </div>
        <div class="w-full p-3 text-center my-3">
            <h5 class="text-lg uppercase">Voucher NO: 
                {{$route.params.voucherNo}}</h5>
        </div>
        <div class="w-full flex flex-wrap p-3">
            <div class="flex-1">
                <h5 class="text-base font-medium">Consultant: {{consultant.names}}</h5>
            </div>
            <div class="flex-1">
                <h5 class="text-base font-medium">Contact: {{consultant.phoneno || `-`}}</h5>
            </div>
            <div class="flex-1">
                <h5 class="text-base font-medium">Reg No: {{consultant.practioninG_NO || `-`}}</h5>
            </div>
            <div class="flex-1">
                <h5 class="text-base font-medium">Qualification: {{consultant.speciality || `-`}}</h5>
            </div>
            <div class="flex-1">
                <h5 class="text-base font-medium">KRA PIN: {{consultant.krapinNo}}</h5>
            </div>
        </div>
        <div class="w-full overflow-visible">
           <table class="table">
            <thead class="font-medium text-sm">
                <tr class="border-b-2">
                    <th class="p-tiny">Bill Date</th>
                    <th class="p-tiny">Patient</th>
                    <th class="p-tiny">Item</th>
                    <th class="p-tiny">Qty</th>
                    <th class="p-tiny text-right">Balance</th>
                    <th class="p-tiny text-right">Voucher Amount</th>
                </tr>
            </thead>
            <tbody class="text-sm">
                <tr class="border-b-2" v-for="(voucherItem,idx) in voucherItems.voucherDetails" :key="idx">
                    <td class="p-tiny">{{voucherItem.billDate | dateFormat}}</td>
                    <td class="p-tiny">
                        <h5 class="font-medium">{{voucherItem.patientName}}</h5>
                        <h5 class="font-medium">MRN:{{voucherItem.patientID}}</h5>
                    </td>
                    <td class="p-tiny">{{voucherItem.itemName}}</td>
                    <td class="p-tiny">{{voucherItem.quantity}}</td>
                    <td class="p-tiny text-right">{{voucherItem.grandTotal | numberFormat}}</td>
                    <td class="p-tiny text-right">{{voucherItem.voucherAmount | numberFormat}}</td>
                </tr>
                <tr>
                    <td colspan="5" class="p-1"></td>
                    <th class="p-tiny text-right text-base">
                        Total: {{total | numberFormat}}
                    </th>
                </tr>
                <tr>
                    <th colspan="6" class="p-tiny text-base">Custom Deductions</th>
                </tr>
                <tr>
                    <th colspan="2" class="p-tiny">Deduction</th>
                    <th class="p-tiny">Rate</th>
                    <th class="p-tiny">Is KRA</th>
                    <th class="p-tiny">Ref</th>
                    <th class="p-tiny text-right">Amount</th>
                </tr>
                <tr v-for="(deduction,idx) in voucherItems.dedcutions.filter(ded => !ded.isKra)" :key="`ded_${idx}`">
                    <td colspan="2" class="p-tiny">{{deduction.deductionName}}</td>
                    <td class="p-tiny">{{deduction.rate}}</td>
                    <td class="p-tiny">{{deduction.isKra ? `Yes` : `No`}}</td>
                    <td class="p-tiny">{{deduction.refNo || `-`}}</td>
                    <td class="p-tiny text-right">{{deduction.deductionAmount | numberFormat}}</td>
                </tr>
                <tr>
                    <td colspan="5" class="p-1"></td>
                    <th class="p-tiny text-right text-base">
                       Custom Total: {{customDeductions | numberFormat}}
                    </th>
                </tr>
                <tr>
                    <th colspan="6" class="p-tiny text-base">KRA Deductions</th>
                </tr>
                <tr v-for="(deduction,idx) in voucherItems.dedcutions.filter(ded => ded.isKra)" :key="`dedk_${idx}`">
                    <td colspan="2" class="p-tiny">{{deduction.deductionName}}</td>
                    <td class="p-tiny">{{deduction.rate}}</td>
                    <td class="p-tiny">{{deduction.isKra ? `Yes` : `No`}}</td>
                    <td class="p-tiny">{{deduction.refNo || `-`}}</td>
                    <td class="p-tiny text-right">{{deduction.deductionAmount | numberFormat}}</td>
                </tr>
                <tr class="border-b-2 border-gray-500">
                    <td colspan="5" class="p-1"></td>
                    <th class="p-tiny text-right text-base">
                        KRA Total: {{kraDeductions | numberFormat}}
                    </th>
                </tr>
                <tr>
                    <td colspan="5" class="p-1"></td>
                    <th class="p-tiny text-right text-base">
                        Total Deductions: {{(customDeductions + kraDeductions) | numberFormat}}
                    </th>
                </tr>
                <tr>
                    <td colspan="5" class="p-1"></td>
                    <th class="p-tiny text-right text-base">
                        Net Total: {{(total-(customDeductions + kraDeductions)) | numberFormat}}
                    </th>
                </tr>
            </tbody>
            </table> 
        </div>
        <div class="my-2 p-2 bg-gray-300 w-full flex flex-wrap">
            <div class="flex-1">
                <h5 class="font-medium text-base">Mode: 
                    {{voucherItems.voucherDetails.length ? voucherItems.voucherDetails[0].extRef : `-`}}</h5>
            </div>
            <div class="flex-1">
                <h5 class="font-medium text-base">Ref: 
                    {{ voucherItems.voucherDetails.length ? 
                        (voucherItems.voucherDetails[0].payRefMemo || voucherItems.voucherDetails[0].paymentRef) : `-` 
                            }}
                </h5>
            </div>
            <div class="flex-1">
                <h5 class="font-medium text-base">Memo: 
                {{voucherItems.voucherDetails.length ? voucherItems.voucherDetails[0].invoiceMemo : `-`}}</h5>
            </div>
        </div>
    </div>
</template>
<style scoped>
@media print {
    tr { page-break-inside:avoid; page-break-after:auto; overflow: visible; }
    td {page-break-inside:avoid; page-break-after:auto; overflow: visible; }
    thead { display: table-row-group; }
}
</style>